import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom-v5-compat';
import { AppFlavour, getDefaultConfig } from '../../../config/app-config';
import { useUserGeoLocation } from '../../../hooks/useUserGeoLocation';
import { BaseStepCompProps } from '../types';

export interface CompanyInfoFormProps
  extends Pick<BaseStepCompProps, 'updateForm' | 'formData' | 'handleNext' | 'handlePrevious'> {
  handleCreateCompany: () => void;
}

const SINGAPORE_COUNTRY_CODE = 'SG';

export const useGetCompanyInfo = (props: CompanyInfoFormProps) => {
  const { updateForm, formData } = props;
  const userLocation = useUserGeoLocation({});

  const [searchParams] = useSearchParams();
  const isRedirected = searchParams.get('switch') === 'true';
  const initiativeCountryCodeParam = searchParams.get('initiativeCountryCode');
  const referralCodeParam = searchParams.get('referralCode');
  const referenceCompanyParam = searchParams.get('referenceCompany');

  useEffect(() => {
    if (formData.initiativeCountryCode) {
      return;
    }

    if (initiativeCountryCodeParam) {
      return updateForm('initiativeCountryCode', initiativeCountryCodeParam);
    }

    if (userLocation) {
      return updateForm('initiativeCountryCode', userLocation);
    }

    if (getDefaultConfig().flavour === AppFlavour.SINGAPORE) {
      return updateForm('initiativeCountryCode', SINGAPORE_COUNTRY_CODE);
    }
  }, [userLocation, formData.initiativeCountryCode, updateForm, initiativeCountryCodeParam]);

  useEffect(() => {
    if (formData.referralCode) {
      return;
    }

    if (referralCodeParam) {
      return updateForm('referralCode', referralCodeParam);
    }
  }, [formData.referralCode, referralCodeParam, updateForm]);

  useEffect(() => {
    if (formData.referenceCompany) {
      return;
    }

    if (referenceCompanyParam) {
      return updateForm('referenceCompany', referenceCompanyParam);
    }
  }, [formData.referenceCompany, referenceCompanyParam, updateForm]);

  return { isRedirected };
};
